<template>
  <div id="logout"></div>
</template>

<script>
  export default {
    name: 'Logout',
    created() {
      this.$store.dispatch('auth/logout')
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Logout.vue